import { useState, useEffect } from "react";
import 'styles/WelcomeMessage.css';

export default function WelcomeMessage(){

  const [hasVisited, setHasVisited] = useState(false);

  useEffect(() => {
    if (hasVisited) localStorage.setItem('hasVisited', 'true')
  }, [hasVisited]);

  if (hasVisited || localStorage.getItem('hasVisited')) {
    return null }
  
  else {
    return (
        <div className="centerer welcome-message-overlay">
          <div className="centered welcome-message">
            <div className="logo"/>
            <div className="welcome-text">
            <h3>Welcome to TagAlong!</h3>
              <p>Some things are <e>merrier</e> when <e>more people</e> show up.</p>
              <p>
                This app allows you to <e>share your upcoming plans</e> with your friends and allows them to join,
                whether it's a gym session, a movie night, or a beach hangout.
              </p>
              <p>Get started by checking out tags on the map or creating your own!</p>
            </div>
            <button className="enter-button" onClick={()=>{setHasVisited(true)}}>Enter</button>
          </div>
        </div>
      )
  }
}